import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout.component';
import { SideNavComponent } from './side-nav/side-nav.component';
import { TopNavComponent } from './top-nav/top-nav.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared/shared.module';
import { ModalUpdateComponent } from './modals/modal-update/modal-update.component';
import { AdminModule } from '../admin/admin.module';
import { TeamModule } from '../team/team.module';

@NgModule({
  declarations: [
    LayoutComponent,
    SideNavComponent,
    TopNavComponent,
    ModalUpdateComponent,
  ],
  imports: [
    RouterModule,
    CommonModule,
    SharedModule,
    AdminModule,
    TeamModule
  ],
  exports: [
    LayoutComponent,
    TopNavComponent
  ],
})
export class LayoutModule { }
